import memoizeOne from 'memoize-one';
import { PricedProduct } from '~/Product';

export default memoizeOne((pricedProducts: PricedProduct<any>[]): number => {
	const count = pricedProducts.reduce((result, pricedProduct) => result + (pricedProduct.price ? 0 : 1), 0);
	return (100 / pricedProducts.length) * count;
});
